import { render, staticRenderFns } from "./DeviceDetailsForm.vue?vue&type=template&id=01b4df2e&"
import script from "./DeviceDetailsForm.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports